import type {
  MirrorAddFilePayload,
  MirrorAddFileResponse,
} from '@modules/mirrors-list/submodules/create/submodules/file/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { MIRRORS_LIST_PERMISSIONS, MIRRORS_LIST_QUERY_KEY } from '@modules/mirrors-list/constants';
import {
  MIRROR_CREATE_FILE_MUTATION_API_URL,
  MIRROR_CREATE_FILE_MUTATION_KEY,
} from '@modules/mirrors-list/submodules/create/submodules/file/constants';
import { useToastStore } from '@modules/toast/store';

export default function useMirrorAddFileMutation(): ReturnType<
    typeof useContextMutation<MirrorAddFileResponse, Error, MirrorAddFilePayload>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    MirrorAddFileResponse,
    Error,
    MirrorAddFilePayload
  >({
    mutationKey: [MIRROR_CREATE_FILE_MUTATION_KEY],
    mutationFn: ({ file, mirror_type }) => fetchPost<MirrorAddFileResponse>(
      MIRROR_CREATE_FILE_MUTATION_API_URL,
      file,
      {
        permission: MIRRORS_LIST_PERMISSIONS.CREATE,
        queryParams: {
          mirror_type,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [MIRRORS_LIST_QUERY_KEY] });
      displayPresetToast('success');
    },
  });
}
